/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const getRouterResourceMetrics = (): {
	ssrRouterResourceTimeouts: string[];
} => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	const ssrRouterResourceTimeouts = window.SPA_STATE
		? // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			Object.keys(window.SPA_STATE).filter((key) => {
				if (key !== key.toUpperCase()) {
					return false;
				}

				// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
				const resource = window.SPA_STATE[key];
				if (typeof resource !== 'object') {
					return false;
				}

				const resourceResponse = resource[Object.keys(resource)[0]];
				return resourceResponse?.error?.name === 'TimeoutError';
			})
		: [];

	return { ssrRouterResourceTimeouts };
};
